<template>
    <div class="orderorder">
        <!-- 单据功能按钮 -->
        <div
            style="display: flex; align-items: center; justify-content: space-between; padding: 0 10px; box-sizing: border-box">
            <div style="display: flex; align-items: center">
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg)"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('1')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg); margin: 0 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('2')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px; margin-right: 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('3')"
                />
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('4')"
                />
            </div>
            <div style="float: right">
                <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    :disabled="isAdd || !isedit"
                    @click="add"
                    v-if="perData.allow_add == 1"
                >{{ $t('common.add') }}
                </el-button
                >
                <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-edit"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="handelEdit"
                    v-if="perData.allow_edit == 1"
                >{{ $t('common.edit') }}
                </el-button
                >
                <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="delOrder"
                    v-if="perData.allow_dele == 1"
                >{{ $t('common.delete') }}
                </el-button
                >
                <el-button type="info" size="mini" @click="goHistory" :disabled="!isedit">{{ $t('common.historyBill')
                    }}
                </el-button>
                <el-button type="primary" :disabled="isAdd || !isedit || nullBtn" plain @click="Check(form.check)">{{
                        form.check == 1 ? $t('common.cancelAudit') : $t('common.audit')
                    }}
                </el-button>
            </div>
        </div>
        <!-- 单据操作信息 -->
        <div class="top_col">
            <el-row :gutter="20">
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.creator') }}：<span>{{ form.build_name }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifier') }}：<span>{{ form.modify_name }}</span>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="grid-content bg-purple">
                        {{ $t('common.createTime') }}：<span>{{ form.build_date }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifyTime') }}：<span>{{ form.modify_date }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditor') }}：<span>{{ form.check_name }}</span>
                    </div>
                </el-col>
                <el-col :span="2">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditStatus') }}：<span
                        :style="{ color: form.check == 1 ? '' : 'red' }">{{ form.check == 1 ? $t('common.audited') : $t('common.notAudited')
                        }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditTime') }}<span>{{ form.check_date }}</span>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 主表表单 -->
        <div class="top_cols" style="padding-bottom: 0">
            <el-form :model="form">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <el-form-item :label="$t('common.billNo') + '：'" label-width="180">
                            <el-input v-model="form.bill_no" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.billDate') + '：'" label-width="180" required>
                            <el-date-picker
                                type="datetime"
                                :disabled="isedit"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期"
                                v-model="form.bill_date"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <div class="input_col">
                            <el-form-item :label="$t('common.billType') + '：'" required>
                                <mySelect
                                    v-model="form.billtype_no"
                                    :options="allArr.billtype"
                                    values="billtype_no"
                                    labels="billtype_name"
                                    keys="billtype_no"
                                    :disable="isedit"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="成品柜台：" label-width="180" required>
                            <mySelect
                                v-model="form.product_counter_no"
                                :options="allArr.counter"
                                values="counter_no"
                                labels="counter_name"
                                keys="counter_no"
                                :disable="isedit"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="物料柜台：" label-width="180" required>
                            <mySelect
                                v-model="form.bom_counter_no"
                                :options="allArr.counter"
                                values="counter_no"
                                labels="counter_name"
                                keys="counter_no"
                                :disable="isedit"
                                @selectChange="onBomCounterChange"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.handler') + '：'" label-width="180">
                            <mySelect
                                v-model="form.staff_no"
                                :options="allArr.staff"
                                values="staff_no"
                                labels="staff_name"
                                keys="staff_no"
                                :disable="isedit"
                            />
                        </el-form-item>
                    </el-col>

                    <el-col :span="4" v-if="systemSet.isstores == 1">
                        <div class="input_col">
                            <el-form-item :label="$t('common.store') + '：'">
                                <mySelect
                                    v-model="form.store_no"
                                    :options="allArr.store"
                                    values="store_no"
                                    labels="store_name"
                                    keys="store_no"
                                    :disable="isedit"
                                    :clearables="false"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="systemSet.isstores == 1 ? 12 : 16">
                        <el-form-item label-width="200" :label="$t('common.remark') + '：'">
                            <el-input type="textarea" :rows="1" v-model="form.remark" :disabled="isedit"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <!-- 拆卸展示区与明细标签页 -->
        <div class="disassembly_body">
            <!-- 左侧：成品数据 + 物料数据（上下布局，高度五五开） -->
            <div class="disassembly_left">
                <!-- 成品数据 From 表单 -->
                <div class="table1 product_panel">
                    <div class="title">
                        <div style="display: flex; align-items: center">
                            <p style="margin-right: 20px">成品数据</p>
                            <!-- 条码号输入框：回车请求接口带出成品与物料数据 -->
                            <input
                                :disabled="isedit"
                                placeholder="请输入条码号"
                                @keydown.enter="insertTableBcode('input', $event)"
                                v-model.lazy="insertKeyword"
                                style="width: 200px; border-radius: 0px !important; font-size: 14px"
                                class="el-textarea__inner"
                            />
                            <el-button
                                style="margin-left: 0px; border-radius: 0px !important"
                                type="primary"
                                :disabled="isedit"
                                @click="dialogTrueFalse"
                            >批量扫码</el-button>
                        </div>
                        <div>
                            <!-- 删除：删除当前在成品明细中选中的成品及其关联物料 -->
                            <el-button size="mini" type="danger" :disabled="isedit || !editingDtlRow"
                                       @click="deleteProductDtl">删除
                            </el-button>
                            <el-button type="" :disabled="isedit" @click="showImpotDialog = true">导入</el-button>
                        </div>
                    </div>
                    <!-- 成品数据表单（只读展示，数据由扫码带出或点击成品明细行回填） -->
                    <el-form :model="productForm" class="product_form" label-width="150px" size="mini">
                        <el-row :gutter="10">
                            <el-col :span="8" v-for="(item, index) in productShowKeyList" :key="item.field + index">
                                <el-form-item :label="item.column_name">
                                    <el-select
                                        v-if="item.column_type == 'select'"
                                        v-model="productForm[item.field]"
                                        filterable
                                        default-first-option
                                        placeholder="请选择"
                                        disabled
                                    >
                                        <el-option
                                            v-for="option in allArr[item.field.replace('_no', '')] || []"
                                            :key="option[item.field.replace('_no', '') + '_no']"
                                            :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                                option[item.field.replace('_no', '') + '_name']
                                            }`"
                                            :value="option[item.field.replace('_no', '') + '_no']"
                                            :disabled="option.status == 0"
                                        ></el-option>
                                    </el-select>
                                    <el-input
                                        v-else
                                        v-model="productForm[item.field]"
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- 物料数据表格（只读展示，数据由扫码带出或点击成品明细行带出） -->
                <div class="table1 material_panel">
                    <div class="title">
                        <p>物料数据</p>
                    </div>
                    <vxe-table
                        border
                        stripe
                        resizable
                        align="center"
                        ref="xTable1"
                        :height="materialHeight"
                        show-overflow
                        show-header-overflow
                        highlight-hover-row
                        :loading="loading"
                        :row-class-name="rowChange"
                        :data="materialList"
                        :key="refushTable"
                        :scroll-y="{ enabled: true, gt: 50 }"
                    >
                        <vxe-table-column type="seq" field="seq" width="70" title="序号">
                            <template slot="header">
                                <i class="el-icon-setting" @click.stop="isedit ? changeTable('145') : null"></i>
                            </template>
                            <template slot-scope="scoped">
                                <span><i style="font-style: normal">{{ scoped.seq }}</i></span>
                            </template>
                        </vxe-table-column>

                        <template v-for="(item, index) in materialKeyList">
                            <vxe-table-column
                                v-if="item.column_status == 1 && item.column_type != 'select'"
                                :title="item.column_name"
                                :field="item.field"
                                :width="item.column_width"
                                :key="item.field + index"
                            >
                                <template #default="{ row }">
                                    <span>{{ row[item.field] }}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column
                                v-if="item.column_status == 1 && item.column_type == 'select'"
                                :title="item.column_name"
                                :field="item.field"
                                :width="item.column_width"
                                :key="item.field + index"
                            >
                                <template #default="{ row }">
                                    <span>{{
                                            $selectLable.selectLable(
                                                row[item.field],
                                                allArr[item.field.replace('_no', '')],
                                                item.field,
                                                item.field.replace('_no', '_name')
                                            )
                                        }}</span>
                                </template>
                            </vxe-table-column>
                        </template>

                        <template #empty>
                            <span style="color: red">
                                <img src="../../../assets/img/dontHave.png" style="width: 200px" />
                            </span>
                        </template>
                    </vxe-table>
                </div>
            </div>
            <!-- 右侧：成品明细/物料明细 tabs（只读） -->
            <div class="disassembly_right">
                <el-tabs v-model="activeTab" type="border-card" class="dtl_tabs" @tab-click="onDetailTabClick">
                    <el-tab-pane label="成品明细" name="productDtl">
                        <vxe-table
                            border
                            stripe
                            resizable
                            align="center"
                            ref="productDtlTable"
                            :height="detailTableHeight"
                            show-overflow
                            show-header-overflow
                            highlight-hover-row
                            :data="form.productDtl"
                            :row-class-name="rowChange"
                            :key="refushTable"
                            :scroll-y="{ enabled: true, gt: 50 }"
                            @cell-click="productDtlRowClick"
                        >
                            <vxe-table-column type="checkbox" width="50"></vxe-table-column>

                            <vxe-table-column type="seq" field="seq" width="70" title="序号">
                                <template slot="header">
                                    <i class="el-icon-setting" @click.stop="isedit ? changeTable('144') : null"></i>
                                </template>
                                <template slot-scope="scoped">
                                    <span><i style="font-style: normal">{{ scoped.seq }}</i></span>
                                </template>
                            </vxe-table-column>

                            <template v-for="(item, index) in productKeyList">
                                <vxe-table-column
                                    v-if="item.column_status == 1 && item.column_type != 'select'"
                                    :title="item.column_name"
                                    :field="item.field"
                                    :width="item.column_width"
                                    :key="item.field + index"
                                >
                                    <template #default="{ row }">
                                        <span>{{ row[item.field] }}</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column
                                    v-if="item.column_status == 1 && item.column_type == 'select'"
                                    :title="item.column_name"
                                    :field="item.field"
                                    :width="item.column_width"
                                    :key="item.field + index"
                                >
                                    <template #default="{ row }">
                                        <span>{{
                                                $selectLable.selectLable(
                                                    row[item.field],
                                                    allArr[item.field.replace('_no', '')],
                                                    item.field,
                                                    item.field.replace('_no', '_name')
                                                )
                                            }}</span>
                                    </template>
                                </vxe-table-column>
                            </template>

                            <template #empty>
                                <span style="color: red">
                                    <img src="../../../assets/img/dontHave.png" style="width: 200px" />
                                </span>
                            </template>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane label="物料明细" name="bomDtl">
                        <vxe-table
                            border
                            stripe
                            resizable
                            align="center"
                            ref="bomDtlTable"
                            :height="detailTableHeight"
                            show-overflow
                            show-header-overflow
                            highlight-hover-row
                            :data="form.bomDtl"
                            :row-class-name="rowChange"
                            :key="refushTable"
                            :scroll-y="{ enabled: true, gt: 50 }"
                        >
                            <vxe-table-column type="seq" field="seq" width="70" title="序号">
                                <template slot="header">
                                    <i class="el-icon-setting" @click.stop="isedit ? changeTable('145') : null"></i>
                                </template>
                                <template slot-scope="scoped">
                                    <span><i style="font-style: normal">{{ scoped.seq }}</i></span>
                                </template>
                            </vxe-table-column>

                            <template v-for="(item, index) in materialKeyList">
                                <vxe-table-column
                                    v-if="item.column_status == 1 && item.column_type != 'select'"
                                    :title="item.column_name"
                                    :field="item.field"
                                    :width="item.column_width"
                                    :key="item.field + index"
                                >
                                    <template #default="{ row }">
                                        <span>{{ row[item.field] }}</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column
                                    v-if="item.column_status == 1 && item.column_type == 'select'"
                                    :title="item.column_name"
                                    :field="item.field"
                                    :width="item.column_width"
                                    :key="item.field + index"
                                >
                                    <template #default="{ row }">
                                        <span>{{
                                                $selectLable.selectLable(
                                                    row[item.field],
                                                    allArr[item.field.replace('_no', '')],
                                                    item.field,
                                                    item.field.replace('_no', '_name')
                                                )
                                            }}</span>
                                    </template>
                                </vxe-table-column>
                            </template>

                            <template #empty>
                                <span style="color: red">
                                    <img src="../../../assets/img/dontHave.png" style="width: 200px" />
                                </span>
                            </template>
                        </vxe-table>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <!-- 页脚表单 -->
        <div class="footer">
            <el-form :inline="true">
                <div>
                    <el-form-item label="成品数量：">
                        <p>{{ productQtyTotal }}</p>
                    </el-form-item>
                    <el-form-item label="成品重量：">
                        <p>{{ productWgtTotal }}</p>
                    </el-form-item>
                    <el-form-item label="物料数量：">
                        <p>{{ bomQtyTotal }}</p>
                    </el-form-item>
                    <el-form-item label="物料重量：">
                        <p>{{ bomWgtTotal }}</p>
                    </el-form-item>
                </div>
            </el-form>
            <div>
                <el-button type="" size="mini" :disabled="isedit" @click="refreshData(form.id)" style="width: 73px">
                    {{ $t('common.cancel') }}
                </el-button>
                <el-button type="primary" :disabled="isedit" size="mini" @click="saveItSub">{{ $t('common.save') }}
                </el-button>
            </div>
        </div>
        <!-- 导入明细弹窗 -->
        <el-dialog title="导入明细" :visible.sync="showImpotDialog" width="45%" :before-close="handleClose">
            <div class="importDialogCenter">
                <div class="centerItem leftItem" @click="outTem">
                    <i class="el-icon-download avatar-uploader-icon"></i>
                    <p class="itemText">点击下载模板</p>
                </div>
                <div class="centerItem">
                    <el-upload
                        class="upload-demo"
                        :on-error="uploadError"
                        :on-success="uploadSuccess"
                        :before-upload="imptBeforeUpload"
                        :show-file-list="false"
                        style="width: 100%"
                        :headers="headers"
                        drag
                        :action="this.$baseURL + 'importDtl_BarcodesDisassembly'"
                        :data="uploadData"
                        multiple
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" style="text-align: center" slot="tip">支持拓展名：.xlsx</div>
                    </el-upload>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showImpotDialog = false">取 消</el-button>
                <el-button type="primary" @click="showImpotDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 批量扫码弹窗 -->
        <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleCloses">
            <!-- 显示标签数量 -->
            <div v-if="dynamicTags.length !== 0">数量: {{ dynamicTags.length }}</div>
            <!-- 标签显示区域 -->
            <el-tag
                v-for="tag in dynamicTags"
                :key="tag"
                closable
                :disable-transitions="false"
                @close="handleCloseTag(tag)"
                effect="plain"
            >
                {{ tag }}
            </el-tag>
            <!-- 输入框区域 -->
            <input
                style="width: 200px"
                class="el-textarea__inner"
                v-model.lazy="inputValuepl"
                ref="saveTagInput"
                size="small"
                @keyup.enter="handleInputConfirmScan"
                @blur="handleInputConfirmScan"
            />
            <!-- 弹窗底部按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="specschange(dynamicTags)">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false"
                   destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index"
                                       @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost"
                                       :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2"
                                           v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm')
                            }}
                        </el-button>
                    </div>
                </div>
            </div>
        </el-drawer>

    </div>
</template>

<script>
import { getExportExcel } from '@/utils/multAdexportExcel.js';
import {
    apiBarcodesDisassemblyGetData,
    apiBarcodesDisassemblyGetBarcodes,
    apiBarcodesDisassemblyGetPull,
    apiBarcodesDisassemblyUpdateData,
    apiBarcodesDisassemblyAddData,
    apiBarcodesDisassemblyDelData,
    apiBarcodesDisassemblycheck,
    apiBarcodesDisassemblyIsAllowUp,
    apiCurrentPermisson,
    apiSystem,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData,
    insjQuitSum
} from '@/request/api';
import { translateColumns } from '@/utils/columnI18n';

export default {
    name: 'BarcodesDisassembly',
    data() {
        return {
            wgtTotal: 0,
            allArr: '',
            form: { remark: '' },
            isedit: true,
            isCheck: false,
            first: null,
            last: null,
            dialogImageUrl: '',
            dialogVisible: false,
            isAdd: false,
            loading: false,
            nullBtn: false,
            systemSet: '',
            isSave: true,
            type: '4',
            maxHeight: 480,
            showImpotDialog: false,
            headers: {},
            topIptInsjOrder: '',
            topLeftForm: {},

            // 条码号输入/批量扫码相关
            insertKeyword: '', // 条码号输入框的值
            insertKeywords: [], // 已带出的条码号列表（用于去重）
            dynamicTags: [], // 批量扫码弹窗中的条码标签列表
            inputValuepl: '', // 批量扫码弹窗输入框的值
            debounceTimeout: null, // 条码输入防抖定时器

            // 列配置操作相关字段
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            // 成品数据列配置（id=144）：成品数据Form与成品明细表格共用
            productKeyList: [],
            originalProductKeyList: [], // 保存原始的成品列配置（包含所有语言）
            // 物料数据列配置（id=145）：物料数据表格与物料明细表格共用
            materialKeyList: [],
            originalMaterialKeyList: [], // 保存原始的物料列配置（包含所有语言）
            // 成品数据From表单对象（只读展示区）
            productForm: {},
            // 物料数据表格数据（只读展示区）
            materialList: [],
            // 当前在成品明细中选中的行（用于删除与回填展示）
            editingDtlRow: null,
            // 明细tabs当前激活页
            activeTab: 'productDtl',
            // 物料数据表格高度
            materialHeight: 500,
            // 明细表格高度（固定值，与容器匹配）
            detailTableHeight: 620,

            uploadData:{},
            keyStatus: '1',
            perData: {} //权限
        };
    },
    computed: {
        /** 成品数据Form展示的列（仅显示已启用字段） */
        productShowKeyList() {
            return this.productKeyList.filter((item) => item.column_status == 1);
        },
        /** 成品数量（成品明细行数） */
        productQtyTotal() {
            let list = this.form.productDtl || [];
            return list.length;
        },
        /** 成品重量（成品明细wgt合计） */
        productWgtTotal() {
            let list = this.form.productDtl || [];
            let total = list.reduce((sum, item) => sum + (Number(item.wgt) || 0), 0);
            return total.toFixed(this.systemSet ? this.systemSet.wgt : 2);
        },
        /** 物料数量（物料明细qty合计） */
        bomQtyTotal() {
            let list = this.form.bomDtl || [];
            let total = list.reduce((sum, item) => sum + (Number(item.qty) || 0), 0);
            return total.toFixed(this.systemSet ? this.systemSet.qty : 2);
        },
        /** 物料重量（物料明细wgt合计） */
        bomWgtTotal() {
            let list = this.form.bomDtl || [];
            let total = list.reduce((sum, item) => sum + (Number(item.wgt) || 0), 0);
            return total.toFixed(this.systemSet ? this.systemSet.wgt : 2);
        }
    },
    mounted() {
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));
        this.getStoneData();
        this.getTable();
        this.getPermission();
        this.$nextTick(() => {
            this.calcTableHeights();
        });
        document.addEventListener('keydown', (event) => {
            this.mykeyup(event);
        });
        let token = sessionStorage.getItem('userToken');
        this.headers.Authorization = 'Bearer ' + token;
        if (this.$route.query.isadd == 0) {
            this.add();
        } else {
            this.geData();
        }
        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalProductKeyList && this.originalProductKeyList.length > 0) {
                    this.productKeyList = translateColumns(this.originalProductKeyList, newLang || 'zh-CN');
                }
                if (this.originalMaterialKeyList && this.originalMaterialKeyList.length > 0) {
                    this.materialKeyList = translateColumns(this.originalMaterialKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    activated() {
        // 从其他页面跳转带bill_no时重新加载数据
        let bill_no = this.$route.query.bill_no;
        if (bill_no) {
            this.geData();
        }
    },
    methods: {
        /** tab切换时触发vxe-table重新布局 */
        onDetailTabClick(tab) {
            this.$nextTick(() => {
                // vxe-table 重新计算布局（doLayout 为 el-table 方法，vxe-table 使用 recalculate）
                if (tab.name === 'productDtl' && this.$refs.productDtlTable) {
                    this.$refs.productDtlTable.recalculate();
                } else if (tab.name === 'bomDtl' && this.$refs.bomDtlTable) {
                    this.$refs.bomDtlTable.recalculate();
                }
            });
        },
        /** 根据容器实际高度计算表格高度 */
        calcTableHeights() {
            setTimeout(() => {
                // 物料数据表格高度 = 物料面板高度 - 标题栏 - padding
                let materialPanel = this.$el.querySelector('.material_panel');
                if (materialPanel && materialPanel.offsetHeight > 0) {
                    let titleEl = materialPanel.querySelector('.title');
                    let titleH = titleEl ? titleEl.offsetHeight : 44;
                    this.materialHeight = materialPanel.offsetHeight - titleH - 30;
                }
            }, 200);
        },
        /** Ctrl+S快捷键保存 */
        mykeyup(e) {
            var key = window.event.keyCode ? window.event.keyCode : window.event.which;
            if (key === 83 && e.ctrlKey) {
                if (!this.isedit) {
                    if (this.$route.path == '/BarcodesDisassembly') {
                        this.saveItSub();
                        e.preventDefault();
                        e.returnValue = false;
                    }
                }
            }
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {
                });
        },

        // 上传文件之前的钩子
        imptBeforeUpload(f) {
            this.uploadData.store_no = this.form.store_no;
            this.uploadData.counter_no = this.form.product_counter_no;
        },
        /** 文件上传成功回调 */
        uploadSuccess(res) {
            if (res.code == 2000) {
                // 后端返回的提示信息数组：存在未获取到的条码时非空，需展示给用户
                const info = (res.data && res.data.info) || [];
                const hasWarnings = Array.isArray(info) && info.length > 0;
                if (hasWarnings) {
                    this.$message({
                        type: 'warning',
                        showClose: true,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: info.join('<br/>')
                    });
                }
                // 按新结构获取成功带出的成品数据与物料数据
                const product = (res.data && res.data.data && res.data.data.product) || [];
                const bom = (res.data && res.data.data && res.data.data.bom) || [];
                if (product.length > 0 || bom.length > 0) {
                    // 物料明细的柜台自动赋值为主表单选择的物料柜台
                    let counterNo = this.form.bom_counter_no || '';
                    let counterItem = (this.allArr.counter || []).find((item) => item.counter_no === counterNo);
                    let counterName = counterItem ? counterItem.counter_name || '' : '';
                    bom.forEach((item) => {
                        item.counter_no = counterNo;
                        item.counter_name = counterName;
                    });
                    this.$set(this.form, 'productDtl', product);
                    this.$set(this.form, 'bomDtl', bom);
                    this.showImpotDialog = false;
                    if (!hasWarnings) {
                        this.$message.success(res.msg);
                    }
                } else if (!hasWarnings) {
                    // 无失败提示且无数据：正常关闭弹窗
                    this.showImpotDialog = false;
                    this.$message.success(res.msg);
                }
            } else {
                if (res.data.info instanceof Array) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: res.data.info.join('<br/>')
                    });
                } else {
                    this.$message.success(res.data.info);
                }
            }
        },
        uploadError(r) {
            this.$message.error('上传失败');
        },
        /** 下载导入模板 */
        outTem() {
            this.$axios
                .get(`${this.$baseURL}templateExport_BarcodesDisassembly`, {
                    params: {
                        token: this.token,
                        type: '明细'
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    let blob = new Blob([response.data]);
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '明细导入模板.xls';
                    link.click();
                });
        },
        /** 加载单据数据 */
        geData(no) {
            this.$load.show();
            this.isedit = true;
            let bill_nos = this.$route.query.bill_no;
            let ids = this.$route.query.id;
            let bill_no = '';
            let id = '';
            if (bill_nos || ids) {
                this.type = null;
                bill_no = bill_nos;
                id = ids;
            }
            if (no) {
                id = no;
            }
            this.isAdd = false;
            apiBarcodesDisassemblyGetData({
                type: this.type,
                id,
                bill_no
            }).then((res) => {
                if (res.code == 2000) {
                    let info = res.data;
                    this.form = info.data;
                    // 初始化成品明细与物料明细数组
                    if (!this.form.productDtl) {
                        this.$set(this.form, 'productDtl', []);
                    }
                    if (!this.form.bomDtl) {
                        this.$set(this.form, 'bomDtl', []);
                    }
                    // 重置成品数据与物料数据展示区
                    this.resetDisassembly();
                    this.calcTableHeights();
                    this.last = info.last;
                    this.first = info.first;
                    this.topLeftForm = info.data.inmain;
                    this.maxHeight = 480;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    if (res.data.info == '暂无数据' || res.data.info == '没有这条数据') {
                        this.form = { productDtl: [], bomDtl: [] };
                        this.$forceUpdate();
                        this.nullBtn = true;
                    }
                    this.$message.error(res.data.info);
                }
            });
            this.$load.close();
        },

        /** 获取成品数据（id=144）与物料数据（id=145）列配置 */
        getTable() {
            apiGetListCorrespondingData({
                id: '144'
            }).then((res) => {
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalProductKeyList = res.data;
                    // 根据当前语言转换列名
                    this.productKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
            apiGetListCorrespondingData({
                id: '145'
            }).then((res) => {
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalMaterialKeyList = res.data;
                    // 根据当前语言转换列名
                    this.materialKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        /** 打开列配置抽屉，type为表格列配置id（144成品/145物料） */
        changeTable(type) {
            if (type == '144') {
                this.keyList = this.productKeyList.map((item) => item);
                this.keyStatus = '144';
            } else if (type == '145') {
                this.keyList = this.materialKeyList.map((item) => item);
                this.keyStatus = '145';
            }
            this.drawers = true;
        },

        checkMove() {
        },
        keycancel() {
            this.drawers = false;
            this.getTable();
        },
        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: this.keyStatus
            }).then((res) => {
                this.keycancel();
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        /** 获取下拉框数据源 */
        getStoneData() {
            apiBarcodesDisassemblyGetPull({}).then((res) => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        /** 撤销编辑，重新加载数据 */
        refreshData(no) {
            this.isedit = true;
            this.isAdd = false;
            this.form = { productDtl: [], bomDtl: [] };
            this.geData(no);
            if (this.$route.query.isadd == 0) {
                this.$router.replace('/BarcodesDisassembly');
            }
        },
        /** 获取物料数据表格最新全量数据 */
        getMaterialFullData() {
            let fullData = [];
            if (this.$refs.xTable1) {
                fullData = this.$refs.xTable1.getTableData().fullData || [];
            } else {
                fullData = this.materialList || [];
            }
            return fullData;
        },
        /** 删除当前选中的成品明细行及其关联物料 */
        deleteProductDtl() {
            if (!this.editingDtlRow) {
                this.$message.warning('请先在成品明细中选择要删除的成品');
                return;
            }
            this.$confirm('确认删除该成品及其关联物料数据？', '提示', {
                type: 'warning'
            }).then(() => {
                let barcode = this.editingDtlRow.barcode;
                // 从成品明细中移除
                let idx = this.form.productDtl.indexOf(this.editingDtlRow);
                if (idx > -1) {
                    this.form.productDtl.splice(idx, 1);
                }
                // 从物料明细中移除相同条码的关联数据
                if (this.form.bomDtl) {
                    let filterBom = this.form.bomDtl.filter((item) => item.barcode != barcode);
                    this.$set(this.form, 'bomDtl', filterBom);
                }
                this.$set(this.form, 'productDtl', this.form.productDtl.slice());
                this.$message.success('删除成功');
                this.resetDisassembly();
            }).catch(() => {
            });
        },
        /** 重置成品数据与物料数据的展示数据 */
        resetDisassembly() {
            this.productForm = {};
            this.materialList = [];
            this.editingDtlRow = null;
        },
        /** 点击成品明细行：回填成品数据Form，并按条码带出物料数据（只读展示） */
        productDtlRowClick({ row }) {
            if (!row) {
                return;
            }
            this.editingDtlRow = row;
            // 该行成品数据带到成品数据Form展示
            this.productForm = this.$deepClone(row);
            // 通过条码barcode获取物料明细中相同条码的数据
            this.materialList = this.$deepClone(
                (this.form.bomDtl || []).filter((item) => item.barcode == row.barcode)
            );
        },
        /** 打开批量扫码弹窗 */
        dialogTrueFalse() {
            if (!this.form.product_counter_no) {
                this.$message.error('请选择成品柜台');
                return;
            }
            // 记录已存在的条码，用于扫码去重
            this.insertKeywords = (this.form.productDtl || []).map((row) => row.barcode);
            this.dialogVisible = true;
        },
        /** 条码号输入框回车：请求接口带出数据并添加到成品明细与物料明细 */
        insertTableBcode(type, e) {
            const v = e.target.value.trim();
            if (!v) {
                return;
            }
            if (e.keyCode == 16 || e.keyCode == 13) {
                // 只处理回车键
                clearTimeout(this.debounceTimeout);
                this.debounceTimeout = setTimeout(async () => {
                    // 检查输入条码是否已存在于成品明细
                    const isDuplicate = (this.form.productDtl || []).some((row) => row.barcode === v);
                    if (isDuplicate) {
                        this.$message.error('输入的条码不能重复。');
                        this.insertKeyword = '';
                        return;
                    }
                    await this.getBarcodesData(v.split(','));
                    this.insertKeyword = '';
                }, 300);
            }
        },
        /** 批量扫码弹窗输入确认：把条码加入标签列表 */
        handleInputConfirmScan() {
            const inputValue = this.inputValuepl.trim();
            clearTimeout(this.debounceTimeout);
            this.$nextTick(() => {
                this.$refs.saveTagInput && this.$refs.saveTagInput.blur();
            });
            this.debounceTimeout = setTimeout(() => {
                if (inputValue && !this.dynamicTags.includes(inputValue)) {
                    // 检查是否与已带出的条码重复
                    let Idx = (this.insertKeywords || []).findIndex((item) => item == inputValue);
                    if (Idx != -1) {
                        this.$message.error('输入的条码不能重复。');
                    } else {
                        this.dynamicTags.push(inputValue);
                    }
                }
                this.inputValuepl = ''; // 清空输入框
                // 保持输入框显示并聚焦
                this.$nextTick(() => {
                    this.$refs.saveTagInput && this.$refs.saveTagInput.focus();
                });
            }, 300);
        },
        /** 批量扫码弹窗移除标签 */
        handleCloseTag(tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        },
        /** 批量扫码弹窗确定：去重后请求接口带出数据 */
        specschange(tags) {
            if (tags.length < 1) {
                this.$message.error('暂无数据,请输入条码号');
                return;
            }
            clearTimeout(this.debounceTimeout);
            this.debounceTimeout = setTimeout(async () => {
                // 找到与成品明细中已存在条码重复的条码
                const duplicateBarcodes = tags.filter((barcode) =>
                    (this.form.productDtl || []).some((row) => row.barcode === barcode)
                );
                if (duplicateBarcodes.length > 0) {
                    // 删除重复的条码并提示
                    tags = tags.filter((barcode) => !duplicateBarcodes.includes(barcode));
                    this.$message({
                        type: 'error',
                        showClose: true,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: `以下条码重复并已被删除：${duplicateBarcodes.join(', ')}`
                    });
                    this.dynamicTags = [...tags];
                    if (this.dynamicTags.length === 0) {
                        return;
                    }
                }
                await this.getBarcodesData(this.dynamicTags);
                this.dynamicTags = [];
                this.dialogVisible = false;
            }, 300);
        },
        /** 关闭批量扫码弹窗 */
        handleCloses(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {
                });
        },
        /** 请求条码数据并添加到成品明细与物料明细表格 */
        async getBarcodesData(barcodes) {
            try {
                const res = await apiBarcodesDisassemblyGetBarcodes({
                    barcode: barcodes,
                    counter_no: this.form.product_counter_no,
                    store_no: this.form.store_no
                });
                if (res.code == 2000) {
                    const product = (res.data.data && res.data.data.product) || [];
                    const bom = (res.data.data && res.data.data.bom) || [];
                    // 添加到成品明细，并重新生成序号，避免多次扫码序号重复
                    const productDtl = [...(this.form.productDtl || []), ...product];
                    productDtl.forEach((item, index) => {
                        item.seq = index + 1;
                    });
                    this.$set(this.form, 'productDtl', productDtl);
                    // 物料明细的柜台自动赋值为主表单选择的物料柜台
                    let counterNo = this.form.bom_counter_no || '';
                    let counterItem = (this.allArr.counter || []).find((item) => item.counter_no === counterNo);
                    let counterName = counterItem ? counterItem.counter_name || '' : '';
                    bom.forEach((item) => {
                        item.counter_no = counterNo;
                        item.counter_name = counterName;
                    });
                    // 添加到物料明细（重新赋值数组触发vxe-table刷新）
                    this.$set(this.form, 'bomDtl', [...(this.form.bomDtl || []), ...bom]);
                    // 更新已扫条码记录用于去重
                    this.insertKeywords = productDtl.map((row) => row.barcode);
                    // info为数组且非空时表示存在未获取到的条码，按警告样式展示
                    const info = res.data.info;
                    if (Array.isArray(info) && info.length > 0) {
                        this.$message({
                            type: 'warning',
                            showClose: true,
                            duration: 0,
                            dangerouslyUseHTMLString: true,
                            message: info.join('<br/>')
                        });
                    } else {
                        this.$message.success(res.msg || '获取成功');
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            } catch (error) {
                console.error('请求失败:', error);
                this.$message.error('请求失败，请重试。');
            }
        },
        /** 物料柜台变化：提示是否同步修改物料数据与物料明细的柜台 */
        onBomCounterChange() {
            // 无物料数据时无需提示
            let hasData =
                (this.form.bomDtl || []).length > 0 ||
                this.getMaterialFullData().some((item) => item.style_no);
            if (!hasData) {
                return;
            }
            this.$confirm('是否同步修改物料数据与物料明细的柜台？', '提示', {
                type: 'warning'
            }).then(() => {
                let counterNo = this.form.bom_counter_no || '';
                let counterItem = (this.allArr.counter || []).find((item) => item.counter_no === counterNo);
                let counterName = counterItem ? counterItem.counter_name || '' : '';
                // 更新物料数据（编辑区表格）的柜台
                let fullData = this.getMaterialFullData();
                fullData.forEach((item) => {
                    this.$set(item, 'counter_no', counterNo);
                    this.$set(item, 'counter_name', counterName);
                });
                this.materialList = fullData.slice();
                // 更新物料明细的柜台，重新赋值数组触发刷新
                (this.form.bomDtl || []).forEach((item) => {
                    this.$set(item, 'counter_no', counterNo);
                    this.$set(item, 'counter_name', counterName);
                });
                this.$set(this.form, 'bomDtl', (this.form.bomDtl || []).slice());
            }).catch(() => {
            });
        },
        /** 点击编辑按钮，检查是否允许编辑 */
        handelEdit() {
            apiBarcodesDisassemblyIsAllowUp({ id: this.form.id }).then((res) => {
                if (res.code == 2000) {
                    // 接口返回允许操作，进入编辑状态
                    this.isSave = true;
                    this.isedit = false;
                    // 清空左侧展示区
                    this.resetDisassembly();
                } else {
                    this.$message.error(res.data.info || '不允许操作');
                }
            });
        },
        /** 保存前校验数据合法性 */
        saveItSub() {
            this.saveIt();
        },
        /** 执行保存（新增/修改） */
        saveIt() {
            if (this.isSave) {
                this.isSave = false;
                let data = this.$deepClone(this.form);
                data.productDtl = this.$deepClone(this.form.productDtl || []);
                data.bomDtl = this.$deepClone(this.form.bomDtl || []);
                delete data.dtl;
                data['inmain'] = this.topLeftForm;
                data['check'] = this.form.check == true ? '1' : '0';

                this.$load.show();
                if (this.isAdd == true) {
                    apiBarcodesDisassemblyAddData({ ...data }).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('添加成功');
                            let info = res.data;
                            this.form = info.data;
                            this.last = info.last;
                            this.first = info.first;
                            this.topLeftForm = info.data.inmain;
                            this.isAdd = false;
                            this.isedit = true;
                            // 初始化明细数组并重置展示区
                            if (!this.form.productDtl) {
                                this.$set(this.form, 'productDtl', []);
                            }
                            if (!this.form.bomDtl) {
                                this.$set(this.form, 'bomDtl', []);
                            }
                            this.resetDisassembly();
                            if (this.$route.query.isadd == 0) {
                                this.$router.replace('/BarcodesDisassembly');
                            }
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info || '保存失败');
                            this.isSave = true;
                        }
                        this.$load.close();
                    }).catch(() => {
                        this.isSave = true;
                        this.$load.close();
                    });
                } else {
                    apiBarcodesDisassemblyUpdateData({ ...data }).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('修改成功');
                            let info = res.data;
                            this.form = info.data;
                            this.last = info.last;
                            this.first = info.first;
                            this.topLeftForm = info.data.inmain;
                            this.isedit = true;
                            // 初始化明细数组并重置展示区
                            if (!this.form.productDtl) {
                                this.$set(this.form, 'productDtl', []);
                            }
                            if (!this.form.bomDtl) {
                                this.$set(this.form, 'bomDtl', []);
                            }
                            this.resetDisassembly();
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info || '保存失败');
                            this.isSave = true;
                        }
                        this.$load.close();
                    }).catch(() => {
                        this.isSave = true;
                        this.$load.close();
                    });
                }
            }
        },
        /** 新增单据，初始化表单数据 */
        add() {
            this.isSave = true;
            if (this.isAdd == false) {
                this.isedit = false;
                this.form = { bill_date: '' };
                this.form.productDtl = [];
                this.form.bomDtl = [];
                this.topLeftForm = {};
                this.form.check = false;
                this.isAdd = true;
                this.isCheck = false;
                this.nullBtn = false;
                this.form.bill_date = this.$getTime();
                this.maxHeight = 480;
                const keys = Object.keys(this.allArr);
                const formKeys = keys.map((key) => `${key}_no`);
                keys.forEach((key, index) => {
                    if (Array.isArray(this.allArr[key])) {
                        const defaultItem = this.allArr[key].find((item) => item.isdefault == 1);
                        if (defaultItem) {
                            if (defaultItem.hasOwnProperty(formKeys[index])) {
                                this.form[formKeys[index]] = defaultItem[formKeys[index]];
                            } else {
                                this.form[formKeys[index]] = '';
                            }
                        } else {
                            this.form[formKeys[index]] = '';
                        }
                    }
                });
                // 主表柜台拆分为成品柜台与物料柜台，均默认带出默认柜台
                const defaultCounter = (this.allArr.counter || []).find((item) => item.isdefault == 1);
                this.form.product_counter_no = defaultCounter ? defaultCounter.counter_no : '';
                this.form.bom_counter_no = defaultCounter ? defaultCounter.counter_no : '';
                setTimeout(() => {
                    // 初始化展示区：清空成品数据与物料数据展示区
                    this.resetDisassembly();
                }, 100);
            } else {
                this.$message.error('请先保存再添加下一个');
            }
            this.type = '4';
        },
        /** 删除当前单据 */
        delOrder() {
            apiBarcodesDisassemblyIsAllowUp({ id: this.form.id }).then((res) => {
                if (res.code === 2000) {
                    this.$confirm('确定要删除吗？', '提示', {
                        type: 'warning'
                    }).then(() => {
                        apiBarcodesDisassemblyDelData({
                            id: this.form.id
                        }).then((res) => {
                            if (res.code == 2000) {
                                this.$message({ message: '删除成功', type: 'success' });
                                if (res.data.data == null) {
                                    this.form = { productDtl: [], bomDtl: [] };
                                    this.nullBtn = true;
                                } else {
                                    this.form = res.data.data;
                                    if (!this.form.productDtl) {
                                        this.form.productDtl = [];
                                    }
                                    if (!this.form.bomDtl) {
                                        this.form.bomDtl = [];
                                    }
                                    if (this.form.check == 1) {
                                        this.isCheck = true;
                                    } else {
                                        this.isCheck = false;
                                    }
                                }
                                this.last = res.data.last;
                                this.first = res.data.first;
                            } else {
                                this.$message.error(res.data.info);
                            }
                        });
                    });
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        /** 同步行序号 */
        rowChange(row) {
            row.row.seq = row.seq;
        },
        /** 审核/撤销审核 */
        Check(val) {
            let check;
            if (this.form.check == 0) {
                check = 1;
            } else {
                check = 0;
            }
            apiBarcodesDisassemblycheck({
                id: this.form.id,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    if (this.form.check == 0) {
                        this.isCheck = true;
                    } else {
                        this.isedit = true;
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
                this.type = '';
                this.geData(this.form.id);
            });
        },
        /** 翻页（上/下/首/末） */
        changePage(v) {
            this.type = v;
            let bill_nos = this.$route.query.bill_no;
            if (bill_nos) {
                this.$router.replace({ path: '/BarcodesDisassembly' });
                this.geData(this.form.id);
                return;
            }
            this.geData(this.form.id);
        },

        /** 调用接口重新计算合计数据（基于成品明细） */
        foottotal() {
            let dtl = this.form.productDtl || [];
            insjQuitSum({ dtl }).then((res) => {
                this.form.sumqty = res.data.sumqty;
                this.form.sumwgt = res.data.sumwgt;
                this.form.sumtrans_wgt = res.data.sumtrans_wgt;
                this.form.tran_qty = res.data.tran_qty;
                this.form.tran_wgt = res.data.tran_wgt;
                this.form.balprc_qty = res.data.balprc_qty;
                this.form.balqty_wgt = res.data.balprc_wgt;
                this.form.sumamt = res.data.sumamt;
                this.form.sumamt2 = res.data.sumamt2;
                this.$forceUpdate();
            });
        },
        /** 获取页面按钮权限 */
        getPermission() {
            apiCurrentPermisson({
                id: '154'
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        /** 获取系统设置信息 */
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        /** 跳转历史单据 */
        goHistory() {
            this.$router.push({ path: '/BarcodesDisassemblyHistory', query: { page: 'BarcodesDisassembly' } });
        }
    }
};
</script>

<style scoped>
.avatar {
    width: 150px;
    height: 150px;
    display: block;
}

/* 拆卸展示区与明细标签页布局 */
.disassembly_body {
    display: flex;
    height: 720px;
    padding: 0 10px;
    box-sizing: border-box;
    margin-top: 10px;

    .disassembly_left {
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        padding-right: 10px;
        box-sizing: border-box;

        .product_panel {
            margin-top: 0;
            height: 55%;
            display: flex;
            flex-direction: column;
            overflow: hidden;

            .title {
                flex-shrink: 0;
            }

            .product_form {
                flex: 1;
                overflow-y: auto;
                padding-right: 10px;
                box-sizing: border-box;

                .el-form-item {
                    margin-bottom: 10px;
                }
            }
        }

        .material_panel {
            height: 45%;
        }
    }

    .disassembly_right {
        width: 50%;
        height: 100%;

        .dtl_tabs {
            height: 100%;

            /deep/ .el-tabs__content {
                height: calc(100% - 39px);
                overflow: hidden;
            }

            /deep/ .el-tabs__item {
                font-weight: bold;
            }
        }
    }
}

.table1 {
    padding: 15px;
    box-sizing: border-box;
    background-color: #fff;
    margin-top: 10px;
    padding-top: 0;

    .title {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        p {
            font-size: 16px;
            color: #000;
        }
    }
}
</style>
<style>
.vxe-table .vxe-body--row.row--stripe {
    background-color: #ecf5ff;
}

.vxe-table thead {
    background-color: #ecf5ff;
}

.vxe-table {
    background: #fff;
}

/* 物料数据表中成品号列禁止编辑，隐藏编辑浮层 */
.orderorder .vxe-table .col--product_seq .vxe-cell--edit {
    display: none !important;
}

.vxe-table .vxe-body--row.row--hover,
.vxe-table .vxe-body--row.row--hover.row--stripe {
    background-color: #ecf5ff;
}

.box1 .el-select {
    width: 20%;
}

.gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
}

.el-select {
    width: 100%;
}

.list-item1:hover {
    background-color: #f5f7fa;
}

.orderorder {
    padding-bottom: 65px;
    box-sizing: border-box;
}

.orderorder .vxe-table .vxe-body--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-footer--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-header--column:not(.col--ellipsis) {
    padding: 12px 0;
}

.orderorder .vxe-table--footer-wrapper.body--wrapper {
    color: red;
}
</style>
<style scoped lang="scss">
.footer {
    height: 88px;
    background-color: #fff;
    z-index: 999;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 10px;
    width: 98%;
    box-shadow: 0px -2px 6px 0px #e2eeff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 40px;
    box-sizing: border-box;

    div {
        display: flex;

        p {
            width: 20%; /* 调整为百分比 */
            min-width: 80px; /* 保证在极小的屏幕上也不会过小 */
        }

        .buttom {
            height: 32px;
            line-height: 0;
        }

        .el-form-item {
            margin-right: 15px;
            margin-bottom: 5px;
        }
    }
}

.importDialogCenter {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;

    .centerItem {
        width: 48%;
        text-align: center;

        /deep/ .el-upload--text {
            width: 100%;
            height: 100%;
        }

        /deep/ .el-upload-dragger {
            width: 100%;
        }
    }

    .leftItem {
        width: 48%;
        height: 180px;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;
        border-radius: 8px;
        border: 1px dashed #97a8be;

        .itemText {
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    line-height: 178px;
    text-align: center;
}
</style>
